<template>
  <div class="magnetic-mirror-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>F_z = -μ ∇_z B | 绝热守恒与粒子反射$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- The Magnetic Field Lines (Converging at ends) -->
          <g v-for="i in 5" :key="i">
             <path :d="getFieldLine(i)" fill="none" stroke="rgba(255, 71, 87, 0.4)" stroke-width="1" />
          </g>

          <!-- The Particles -->
          <g v-for="(p, idx) in particles" :key="idx">
             <!-- Helical Path -->
             <circle :cx="p.x" :cy="p.y" r="3" fill="#ffd700">
                <animate attributeName="opacity" values="1;0.5;1" dur="0.2s" repeatCount="indefinite" />
             </circle>
             <!-- Trail -->
             <polyline :points="p.trail" fill="none" stroke="#ffd700" stroke-width="0.5" opacity="0.3" />
          </g>

          <!-- Magnetic Coils (The Mirrors) -->
          <rect x="50" y="80" width="10" height="80" fill="#444" rx="2" />
          <rect x="340" y="80" width="10" height="80" fill="#444" rx="2" />
          <text x="35" y="70" fill="#888" font-size="8">强磁场区</text>
          <text x="330" y="70" fill="#888" font-size="8">强磁场区</text>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>绝热不变性: μ = mv⊥²/2B ≈ Const</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row items-center">
             <label>磁镜强度</label>
             <el-slider v-model="mirrorRatio" :min="1.5" :max="5" :step="0.1" size="mini"></el-slider>
          </div>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>磁镜效应是等离子体物理中的基本现象。当带电粒子在非均匀磁场中运动，并进入磁场增强的区域时，根据**磁矩守恒（μ=不变）**，其垂直动能会增加。由于总动能守恒，其平行于磁场的速度必须减小。如果平行速度减为零，粒子就会被“弹回”，就像撞到了镜子一样。这一原理构成了地球磁层自旋管（范艾伦辐射带）捕获粒子的基础，也是早期核聚变磁约束装置的核心原理。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MagneticMirrorViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      mirrorRatio: 2.5,
      particles: [],
      t: 0,
      timer: null
    }
  },
  methods: {
    getFieldLine(i) {
       let y = 120 + (i - 3) * 40;
       return `M 0,${y} Q 200,${y + (i-3)*-20} 400,${y}`;
    },
    update() {
       this.t += 0.05;
       if (this.particles.length < 3) {
          this.particles.push({
             x: 200,
             y: 120,
             vx: (Math.random() - 0.5) * 4,
             vy: 0,
             theta: 0,
             trail: ""
          });
       }

       this.particles.forEach(p => {
          // B magnitude (simple model: stronger at ends)
          let bx = Math.abs(p.x - 200);
          let B = 1 + (bx/200)*this.mirrorRatio;
          
          // Force: F = -mu * grad B
          let gradB = (p.x > 200 ? 1 : -1) * this.mirrorRatio / 200;
          let mu = 10;
          let ax = -mu * gradB;
          
          p.vx += ax;
          p.x += p.vx;
          
          // Larmor rotation
          p.theta += 0.5 * B;
          let r = 5 / B;
          p.y = 120 + Math.sin(p.theta) * r;

          // Keep trail
          p.trail += `${p.x},${p.y} `;
          if (p.trail.split(' ').length > 50) {
             p.trail = p.trail.substring(p.trail.indexOf(' ') + 1);
          }

          if (p.x < 10 || p.x > 390) p.vx *= -1; // Fallback
       });

       this.timer = requestAnimationFrame(this.update);
    }
  },
  mounted() { this.update(); },
  beforeDestroy() { cancelAnimationFrame(this.timer); }
}
</script>

<style scoped lang="scss">
.magnetic-mirror-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(255, 71, 87, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
